import React from 'react';
import '../styles/home.css';


class Findme extends React.Component{
    
    render(){
        return(
            <div className='findme-content'>
                 <div className='row find-row'>
                    <div className='col-md-4 logo-container'>
                        <a href="https://github.com/Pooya-Oladazimi" className='logo-link' target="_blank">
                            <i class="fa fa-github logo-icon"></i>
                            <br></br>Github
                        </a>                    
                    </div>

                    <div className='col-md-4 logo-container'>
                        <a href="https://www.kaggle.com/oladazimi/code" className='logo-link' target="_blank">
                            <i class="fa fa-bar-chart logo-icon"></i>
                            <br></br>Kaggle
                        </a>                    
                    </div>
                    <div className='col-md-4 logo-container'>
                        <a href="https://www.linkedin.com/in/pooya-oladazimi/" className='logo-link' target="_blank">
                            <i class="fa fa-linkedin logo-icon"></i>
                            <br></br>Linkedin
                        </a>                    
                    </div>
                </div>

                <div className='row find-row'>
                    <div className='col-md-4 logo-container'>
                        <a href="https://www.xing.com/profile/Pooya_Oladazmi/cv" className='logo-link' target="_blank">
                            <i class="fa fa-xing logo-icon"></i>
                            <br></br>Xing
                        </a>                    
                    </div>

                    <div className='col-md-4 logo-container'>
                        <a href="https://scholar.google.com/citations?user=WnUi1WgAAAAJ&hl=en" className='logo-link' target="_blank">
                            <i class="fa fa-graduation-cap logo-icon"></i>
                            <br></br>Scholar
                        </a>                    
                    </div>
                    <div className='col-md-4 logo-container'>
                        <a href="https://www.polaz.net/" className='logo-link' target="_blank">
                            <i class="fa fa-coffee logo-icon"></i>
                            <br></br>My Blog (Polaz.net)
                        </a>                    
                    </div>
                </div>
            </div>           
        );
    }
}

export default Findme;